import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import { customer as CustomerApi } from '@teem/core/constants/api';
import { LoaderService } from '@teem/app/core/services/loader.service';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { ProfileService } from '@teem/app/core/services/profile.service';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';
declare var google: any;
@Component({
  selector: 'app-address-modal',
  templateUrl: './address-modal.component.html',
  styleUrls: ['./address-modal.component.scss']
})
export class AddressModalComponent {
  @ViewChild('search', { static: false }) searchElementRef!: ElementRef;
  private geoCoder;
  public marker = { latitude: null, longitude: null };
  public zoom: number;
  public address: string;
  customerInfoForm: FormGroup;
  outsideSA: boolean = true;
  isSubmitted: boolean = false;

  selectedCountry: any;
  cities: any = '';
  districts: any = '';
  selectedDistrict: any;
  selectedRegion: any;
  selectedCity: any;

  tempFormattedAddress: any;

  countryListApi: string = CustomerApi.endPoint;
  regionListApi: string = CustomerApi.regions;
  cityListApi: string = CustomerApi.cities;

  constructor(
    public activeModal: NgbActiveModal,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private profileService: ProfileService,
    private sharedDataService: SharedDataService
  ) {

    this.customerInfoForm = this.fb.group({
      address_name: ['home', Validators.required],
      building_name: [null, Validators.required],
      street: [null, Validators.required],
      area: [null, Validators.required],
      // address: [null, Validators.required],
      region: [null],
      country_id: [null, Validators.required],
      zipcode: [null],
      // district: [null],
      city: [null],
      city_id: [null],
      region_id: [null],
      district_id: [null],
      pin_drop_location: [null],
      address: [null],
      is_default: [null],
    });
  }

  isDropdownOpen: { [key: string]: boolean } = {};
  ngAfterViewInit(): void {
    this.findAddress();
  }

  get f() {
    return this.customerInfoForm.controls;
  }

  findAddress() {
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ['geocode']
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry == null) {
            return;
          }
          this.address = place.formatted_address;
          this.marker = { latitude: place.geometry.location.lat(), longitude: place.geometry.location.lng() }
          this.setAddress(place);
          this.zoom = 12;
        });
      });
    });
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.marker.latitude = position.coords.latitude;
        this.marker.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress({ lat: position.coords.latitude, lng: position.coords.longitude });
      });
    }
  }


  getAddress(location) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: location }, (results, status) => {
      if (status == google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;
          this.setAddress(results[0]);
        } else {
          console.log('No results found');
        }
      } else {
        console.log('Geocoder failed due to: ' + status);
      }
    });
  }

  setAddress(address) {
    const components = address.address_components;
    this.tempFormattedAddress = address.formatted_address;
    let area = '';
    this.customerInfoForm.get('zipcode').setValue(null);
    components.forEach(component => {
      if (component.types.includes('street_number')) {
        this.setFieldValue('street', component.long_name)
      }
      if (component.types.includes('country')) {
        setTimeout(() => {
          this.setSelect2Country(component.long_name)
        }, 500);
      }
      if (component.types.includes('postal_code')) {
        this.setFieldValue('zipcode', component.long_name)
      }
      if (component.types.includes('administrative_area_level_3') || component.types.includes('locality')) {
        if (this.outsideSA) {
          this.setFieldValue('city', component.long_name)
        }
      }
      if (component.types.includes('sublocality')) {
        area = area + ' ' + component.long_name
      }
    });

    this.setFieldValue('area', area);
  }

  setFieldValue(field: string, value: any) {
    this.customerInfoForm.get(field)?.setValue(value);
  }

  // setSelect2Region(text: string) {
  //   const lowerSearch = text.toLowerCase();

  //   const matchingOption = $('#selectToRegion option').filter(function () {
  //     // return $(this).text().toLowerCase().includes(lowerSearch);
  //     return lowerSearch.includes($(this).text().toLowerCase());
  //   });

  //   if (matchingOption.length) {
  //     const valueToSelect = matchingOption.first().val();
  //     console.log(matchingOption);
  //     $('#selectToRegion').val(valueToSelect).trigger('change');
  //     setTimeout(() => {
  //       this.setSelect2City(this.tempFormattedAddress)
  //     }, 1000)
  //   } else {
  //     console.warn('No match found for text:', text);
  //   }
  // }

  setSelect2Country(text: string) {
    const option = $('#selectToCountry option').filter(function () {
      return $(this).text().trim() === text;
    });

    if (option.length) {
      // $('#selectToCountry').val(option.val()).trigger('change');
      this.selectedCountry = {
        id: option.val(),
        name: option.text()
      }
      this.setFieldValue('country_id', option.val());
      if (option.val() == 682) {
        this.outsideSA = false;
        setTimeout(() => {
          this.setSelect2City(this.tempFormattedAddress)
        }, 800)
      } else {
        this.outsideSA = true;
      }
    } else {
      console.warn('Text not found in options:', text);
    }
  }

  setSelect2City(text: string) {
    const lowerSearch = text.toLowerCase();
    const matchingOption = $('#selectToCity option').filter(function () {
      const optionText = $(this).text().toLowerCase();
      return optionText && lowerSearch.includes(optionText); // Check if input contains the option text
    });

    if (matchingOption.length) {
      const valueToSelect = matchingOption.first().val();
      // $('#selectToCity').val(valueToSelect).trigger('change');
      this.selectedCity = {
        id: matchingOption.first().val(),
        name: matchingOption.first().text()
      }
      this.setFieldValue('city_id', matchingOption.first().val());
      this.onChangeCity({ 'id': valueToSelect })
    } else {
      console.warn('No match found for text:', text);
    }
  }

  setSelect2District(text: string) {
    const lowerSearch = text.toLowerCase();
    const matchingOption = $('#selectToDistrict option').filter(function () {
      let optionText = $(this).text().toLowerCase();
      optionText = optionText.replace("dist.", "")
        .replace("al", "")
        .replace(/\s+/g, ""); // remove all spaces
      if (optionText) {
        return lowerSearch.includes(optionText); // flipped this
      }
    });

    if (matchingOption.length) {
      const districtId = matchingOption.first().val();
      const districtName = matchingOption.first().text();
      this.selectedDistrict = {
        id: districtId,
        name: districtName
      }
      this.setFieldValue('district_id', this.selectedDistrict);
    } else {
      console.warn('No match found for text for district:', text);
    }
  }


  markerDragEnd($event: MouseEvent) {
    this.marker.latitude = $event.coords.lat;
    this.marker.longitude = $event.coords.lng;
    this.getAddress($event.coords);
  }

  closeModal(marker, address) {
    this.activeModal.close({ marker: marker, address: address ?? null });
  }

  toggleDropdown(key: string): void {
    this.isDropdownOpen[key] = !this.isDropdownOpen[key];
  }

  closeDropdown(key: string): void {
    this.isDropdownOpen[key] = false;
  }

  markFieldsAsTouched(fields: string[]) {
    fields.forEach(field => {
      this.customerInfoForm.get(field)?.markAsTouched();
    });
  }

  validateInput(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.charCode);

    // Regular expression to allow only English, Arabic characters and numbers
    const regex = /^[\u0621-\u064A\u0660-\u0669A-Za-z0-9 ]+$/;

    if (!regex.test(inputChar)) {
      event.preventDefault(); // Block the input if it's not a valid character
    }
  }

  onCountryChangeTrigger(event: any) {
    const selectedId = event.id;
    const selectedText = event.text;
    this.getCoordinates(selectedText);
    this.onChangeCountry({ id: selectedId, text: selectedText });
  }

  onChangeCountry(item) {
    let countryId = item.id;
    if (countryId == 682) {
      this.outsideSA = false;
      this.customerInfoForm.get('city').setValue(null);
      this.customerInfoForm.get('zipcode').setValue(null);
      ['city','zipcode']?.forEach((field: string) => {
        this.customerInfoForm.get(field).setValue(null);
        this.customerInfoForm.get(field).clearValidators();
        this.customerInfoForm.get(field).updateValueAndValidity();
      });
      ['city_id', 'district_id']?.forEach((field: string) => {
        this.customerInfoForm.get(field).setValidators([Validators.required]);
        this.customerInfoForm.get(field).updateValueAndValidity();
      });

    } else {
      this.outsideSA = true;
      ['city'].forEach((field: string) => {
        this.customerInfoForm.get(field).setValidators([Validators.required]);
        this.customerInfoForm.get(field).updateValueAndValidity();
      });

      ['city_id', 'district_id'].forEach((field: string) => {
        this.customerInfoForm.get(field).setValue(null);
        this.customerInfoForm.get(field).clearValidators();
        this.customerInfoForm.get(field).updateValueAndValidity();
      });
    }
  }

  onChangeRegion(item) {
    let region = item.id;
    if (region) {
      this.loaderService.startLoading();
      this.profileService.getCities(region).subscribe((data: any) => {
        this.cities = data;
        this.loaderService.stopLoading();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  onChangeCity(item) {
    let city = item.id;
    if (city) {
      this.loaderService.startLoading();
      this.profileService.getDistricts(city).subscribe((data: any) => {
        this.districts = data;
        this.loaderService.stopLoading();
        this.setSelect2District(this.tempFormattedAddress);
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  getCoordinates(address: string): void {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, (results, status) => {
      if (status === 'OK' && results[0]) {
        this.marker.latitude = results[0].geometry.location.lat();
        this.marker.longitude = results[0].geometry.location.lng();
      } else {
        console.error('Geocoding failed: ' + status);
      }
    });
  }

  submit() {
    this.isSubmitted = true;
    if (this.customerInfoForm.valid) {
      this.customerInfoForm.get('pin_drop_location').setValue(this.marker);
      this.customerInfoForm.get('address').setValue(this.address);

      const addressData = this.customerInfoForm.value
      this.loaderService.startLoading();
      this.profileService.addAddress(addressData).subscribe({
        next: (res) => {
          this.loaderService.stopLoading();
          this.closeModal(null, null);
          this.sharedDataService.setItem('customerInfo', res);
          Swal.fire(i18n.alert.success, i18n.address.added_successfully, 'success');
        },
        error: (err) => {
          this.loaderService.stopLoading();
          const errors = err.error?.errors;
          // console.log(errors);
          if (errors?.email) {
            this.customerInfoForm.get('email')?.setErrors({ serverError: errors.email[0] });
          }

          if (errors?.phone) {
            this.customerInfoForm.get('phone')?.setErrors({ serverError: errors.phone[0] });
          }
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        },
      });
    } else {
      this.customerInfoForm.markAllAsTouched();
      console.log("Form is invalid. Errors:");

      Object.keys(this.customerInfoForm.controls).forEach(controlName => {
        const control = this.customerInfoForm.get(controlName);
        if (control && control.invalid) {
          console.log(`Control: ${controlName}, Errors:`, control.errors);
        }
      });
    }
  }
}